import { WIZARD_STATE_KEY_NAME } from '@/consts/localStorage';
import {
    INFORMATION_SCREEN,
    MULTIPLE_CHOICE_QUESTION_TYPE,
    MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
    GATED_MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
    MULTIPLE_CHOICE_WITH_TITLE_AND_TEXT_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE,
    TEXT_ANSWER_QUESTION_TYPE,
    GATED_TEXT_ANSWER_QUESTION_TYPE,
    YES_NO_QUESTION_TYPE
} from '@/consts/questionTypes';

export class LocalStorageService {
    uuidv4 = () => {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }

    getState = () => {
        return JSON.parse(localStorage.getItem(WIZARD_STATE_KEY_NAME));
    };   

    questionAnswered = (question) => {
        switch (question.type) {
                case INFORMATION_SCREEN:
                    return question.userConfirmed;                    

                case YES_NO_QUESTION_TYPE:
                    return question.userAnswer?.length > 0;

                case MULTIPLE_CHOICE_QUESTION_TYPE:
                    return question.userAnswers?.some(answer => answer.selected);

                case MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE:
                   return question.userAnswers?.some(answer => answer.selected);

                case GATED_MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE:
                    return question.userAnswers?.some(answer => answer.selected) || question.conditionDismissed;

                case MULTIPLE_CHOICE_WITH_TITLE_AND_TEXT_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE:
                    return question.userAnswers?.some(answer => answer.selected);

                case TEXT_ANSWER_QUESTION_TYPE:
                    return question.userAnswer?.length > 0;

                case GATED_TEXT_ANSWER_QUESTION_TYPE:
                    return question.userAnswer?.length > 0 || question.conditionDismissed;                    

                default:
                    break;
            }
    };

    setupLocalStorageState = questions => {
        

        const initialState = questions.map(question => {
            switch (question.type) {
                case INFORMATION_SCREEN:
                    return {
                        ...question,
                        userConfirmed: false
                    };

                case YES_NO_QUESTION_TYPE:
                    return {
                        ...question,
                        userAnswer: ''
                    };

                case MULTIPLE_CHOICE_QUESTION_TYPE:
                    return {
                        ...question,
                        userAnswers: [...question.answers.map(answer => ({ answer, key : this.uuidv4() ,selected: false}))]                        
                    };

                case MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE:
                    return {
                        ...question,                        
                        userAnswers: [...question.answers.map(answer => ({ answer, key : this.uuidv4(), selected: false }))]
                    };

                case GATED_MULTIPLE_CHOICE_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE:
                    return {
                        ...question,
                        conditionDismissed: false,
                        userAnswers: [...question.answers.map(answer => ({ answer, key : this.uuidv4(), selected: false }))]
                    };

                case MULTIPLE_CHOICE_WITH_TITLE_AND_TEXT_WITH_ADDITIONAL_ANSWERS_QUESTION_TYPE:
                    return {
                        ...question,
                        userAnswers: [...question.answers.map(answer => ({ ...answer, key : this.uuidv4(), selected: false }))]
                    };

                case TEXT_ANSWER_QUESTION_TYPE:
                    return {
                        ...question,                        
                        userAnswer: ''
                    };
                case GATED_TEXT_ANSWER_QUESTION_TYPE:
                    return {
                        ...question,
                        conditionDismissed: false,
                        userAnswer: ''
                    };

                default:
                    break;
            }
        });

        localStorage.setItem(WIZARD_STATE_KEY_NAME, JSON.stringify(initialState));
    };
    
    getQuestionState = id => {
        const state = JSON.parse(localStorage.getItem(WIZARD_STATE_KEY_NAME));

        return state.find(questionState => questionState.id === id);
    };

    updateQuestionState = (id, newState) => {
        const state = JSON.parse(localStorage.getItem(WIZARD_STATE_KEY_NAME));

        const updatedState = state.map(question => (question.id === id ? { ...question, ...newState } : question));

        localStorage.removeItem(WIZARD_STATE_KEY_NAME);
        localStorage.setItem(WIZARD_STATE_KEY_NAME, JSON.stringify(updatedState));
    };

    clearState = () => {
        localStorage.removeItem(WIZARD_STATE_KEY_NAME);
    };
}
